<dx-popup
  [title]="title"
  [(visible)]="visible"
  width="1000px"
  height="600px"
  [showCloseButton]="false"
  (onShown)="onShown()">
  <div *dxTemplate="let t = data; of: 'content'">
    <div class="loaderContent">
      @if (!this.isLoading2()) {
        <div>{{ ticket.violation_information }}</div>

        <dx-toolbar style="margin-top: 20px">
          <dxi-item location="before">
            <dx-button
              #submitButton
              text="Ok"
              (onClick)="onSubmit($event)"
              icon="../../../assets/images/Check_16x16.png"></dx-button>
          </dxi-item>
        </dx-toolbar>
      } @else {
        <app-loading-div></app-loading-div>
      }
    </div>
  </div>
</dx-popup>
